import {ErrorMessage} from './error-page';
import {useTranslation} from '../../../hooks/use-translation';

/**
 * The page for a URL that has no route. Back only when there is a page to go back to: a URL typed in a new tab has
 * none, the button would do nothing.
 */
const NotFoundPage = (): React.JSX.Element => {
    const t = useTranslation();

    return (
        <ErrorMessage heading={t('notFound.heading')} message={t('notFound.message')}>
            <footer>
                {1 < window.history.length && (
                    <button type="button" className="button" onClick={() => window.history.back()}>
                        {t('errorPage.back')}
                    </button>
                )}
                <button type="button" className="button button-primary" onClick={() => (window.location.href = '/')}>
                    {t('errorPage.home')}
                </button>
            </footer>
        </ErrorMessage>
    );
};

export default NotFoundPage;
